import React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

const ID = 'play-control-icon';
export const PlayControlIcon = ({ fill = 'white', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            data-testid={ID}
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g id={ID} stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g>
                    <rect id="Background" x="0" y="0" width="24" height="24"></rect>
                    <g transform="translate(4.000000, 2.000000)" id="Path" className={fillStyles}>
                        <path d="M4.00625191,0.933046207 C4.01820191,0.941016207 4.03019191,0.949006207 4.04222191,0.957036207 L14.5910019,7.98951621 C14.8962019,8.19291621 15.1792019,8.38161621 15.3965019,8.55691621 C15.6234019,8.73981621 15.8908019,8.99351621 16.0447019,9.36461621 C16.2481019,9.85511621 16.2481019,10.4064162 16.0447019,10.8969162 C15.8908019,11.2680162 15.6234019,11.5216162 15.3965019,11.7046162 C15.1792019,11.8799162 14.8962019,12.0685162 14.5910019,12.2719162 L4.00628191,19.3284162 C3.63319191,19.5771162 3.29772191,19.8008162 3.01305191,19.9551162 C2.72818191,20.1095162 2.33717191,20.2859162 1.88080191,20.2586162 C1.29705191,20.2238162 0.757791911,19.9352162 0.404981911,19.4688162 C0.129161911,19.1042162 0.0590519108,18.6810162 0.0294919108,18.3584162 C-4.4408921e-16,18.0359162 -4.4408921e-16,17.6327162 -4.4408921e-16,17.1843162 L-4.4408921e-16,3.12036621 C-4.4408921e-16,3.10590621 -4.4408921e-16,3.09148621 -4.4408921e-16,3.07711621 C-4.4408921e-16,2.62872621 -4.4408921e-16,2.22552621 0.0294919108,1.90310621 C0.0590519108,1.58044621 0.129161911,1.15724621 0.404981911,0.792636207 C0.757791911,0.326266207 1.29705191,0.0376662075 1.88080191,0.00280620746 C2.33717191,-0.0244437925 2.72818191,0.151966207 3.01305191,0.306346207 C3.29771191,0.460616207 3.63317191,0.684296207 4.00625191,0.933046207 Z"></path>
                    </g>
                </g>
            </g>
        </svg>
    );
};
PlayControlIcon.TEST_ID = ID;
